import { gql } from '@apollo/client';

const ProductionOrderInfoPartner = gql`
  fragment ProductionOrderInfoPartner on ProductionOrder {
    id
    account {
      id
      accountNumber
    }
    address
    arches
    createdAt
    hexCode
    legacyId
    lowerArchQuantity
    manufacturerCompletedAt
    manufacturerDiscardAt
    manufacturerInProcessAt
    manufacturerInTransitAt
    manufacturerOnHoldAt
    order {
      id
      hexCode
    }
    partnerLocation {
      id
      name
    }
    partnerState
    patient {
      id
      firstName
      lastName
      dob
      birthDay
      birthMonth
      birthYear
    }
    productionOrderItemsAttributes {
      id
      name
      quantity
      trackingNumber
      eta
      deliveredAt
      trackingUrl
      labelUrl
      shippingCarrier {
        id
        name
      }
      product {
        id
        name
        featuredImage
        warrantyAllowed
      }
      patient {
        id
        firstName
        lastName
        dob
      }
    }
    projectedDeliveredAt
    sendToClinic
    state
    updatedAt
    upperArchQuantity
    user {
      id
      firstName
      lastName
      email
      phone
    }
  }
`;

export default ProductionOrderInfoPartner;
